import React, {
  useCallback,
  useEffect,
  useState,
  useMemo,
  useRef,
  useForm,
} from "react";
import {
  Card,
  Pagination,
  Button,
  ConfigProvider,
  Input,
  Select,
  Form,
  Modal,
  Col,
} from "antd";
import Http from "../../networkReq/http";
import Request from "../../networkReq/request";
import { useHistory } from "react-router-dom";
import ServiceApplication from "./ServiceApplication";
import ImbarkBase from "./ImbarkBase";
import EntrepreneurialExpert from "./EntrepreneurialExpert";
import FinancialService from "./FinancialService";
import "./index.scss";
import { getDictOne } from "../../utils/storage";
import one from "../../images/home/one.png";
import two from "../../images/home/two.png";
import three from "../../images/home/three.png";
import zh_CN from "antd/es/locale/zh_CN";
const { TextArea } = Input;
const { Search } = Input;
const { Option } = Select;
const industry = getDictOne("industry_code");
const region = [
  { city: "创业服务申请", id: 1 },
  // { city: "创业基地", id: 2 }, 18090 就业创业网门户--首页，创业帮扶分为创业资金申请，创业服务支持和创业优惠政策三个板块，取消“创业基地”板块
  { city: "创业专家", id: 3 },
  { city: "创业金融服务", id: 4 },
];

function itemRender(current, type, originalElement) {
  if (type === "prev") {
    return <a>上一页</a>;
  }
  if (type === "next") {
    return <a>下一页</a>;
  }
  return originalElement;
}
const data = [
  { text: "农业", id: 1 },
  { text: "地产", id: 2 },
  { text: "金融", id: 3 },
  { text: "运输业", id: 4 },
  { text: "餐饮", id: 5 },
  { text: "制造业", id: 6 },
];
export default function JobCollection(props) {
  const [currentPage, setCurrentPage] = useState(1); //当前页数
  const [defaultValues, setDefaultValues] = useState("");
  const [searchValue, setSearchValue] = useState(""); //搜索框value值
  const [currentCity, setCurrentCity] = useState(1); //城市
  const [currentCityTwo, setCurrentCityTwo] = useState("创业服务支持");
  const [countyLevel, setCountyLevel] = useState(0); //眉山市或其他市
  const [succeed, setSucceed] = useState(0); //收藏
  const [succeedTwo, setSucceedTwo] = useState(0); //收藏
  const [moneyList, setMoneyList] = useState([]); //发行机构
  const [selectValue, setSelectValue] = useState("");
  const [selectValue2, setSelectValue2] = useState("");

  const history = useHistory();

  useEffect(() => {
    const { location } = history;
    if (location.params && location.params.activeyKey) {
      setCurrentCity(location.params.activeyKey - 0);
    }
  }, [history]);

  const handleChangeCity = useCallback((value, city) => {
    setSearchValue("");
    setCurrentCityTwo(city);
    setCurrentCity(value);
  }, []);
  
  const onSearch = (value) => {
    setSearchValue(value);
  };

  useEffect(() => {
    Http.get(Request.moneyList(), {}, (obj) => {
      if (obj.code == 200) {
        setMoneyList(obj.data);
      }
    });
  }, []);

  const initiaList = useCallback(() => {
    let params = {
      size: 5,
      address: currentCityTwo == "不限" ? "" : currentCityTwo,
      current: currentPage,
      type: countyLevel,
      text: searchValue,
      descs: "update_time",
    };
  });
  useEffect(() => {
    const {
      location: { search },
    } = history;
    console.log("searchsearch", search.slice(-1));

    switch (Number(search.slice(-1))) {
      case 1:
        handleChangeCity(4, "创业金融服务");
        break;
      case 2:
        handleChangeCity(3, "创业专家");
        break;
      default:
        break;
    }
  }, [handleChangeCity, history]);
  useEffect(() => {
    console.log(history);

    initiaList();
  }, [
    currentPage,
    countyLevel,
    succeed,
    currentCityTwo,
    searchValue,
    succeedTwo,
    selectValue,
    history,
    initiaList,
  ]);

  return (
    (
      <div className={"createAssist_app"}>
        <div
          className={"getjob_Search"}
          style={{ padding: "16px 0", background: "#FBFBFB" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", paddingLeft: 15 }}>
            <div>
              <span>当前位置：创业帮扶 / </span>
              <span style={{ color: "#3356C5", cursor: "pointer" }}>
                {" "}
                {currentCityTwo}
              </span>
            </div>
          </div>

          <div style={{fontSize: 18, fontWeight: 'bold', marginTop: 10, marginLeft: 15, textAlign: 'center'}}>
            眉山市退役军人创业导师
          </div>

          {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: 30 }}>
            <div>
              <div>
                <Input.Group compact style={{ display: "flex" }}>
                  <Form.Item
                    style={{ display: "flex", marginLeft: "10px" }}
                    name="gender"
                    label="关键字"
                    rules={[{ required: true }]}
                  >
                    <Search
                      style={{ width: "300px" }}
                      placeholder="搜索专家名称"
                      allowClear
                      enterButton="搜索"
                      size="large"
                      onSearch={onSearch}
                    />
                  </Form.Item>
                </Input.Group>
              </div>
            </div>
          </div> */}
        </div>
        <div className={"getjob_major"} style={{ paddingTop: 20}}>
          <EntrepreneurialExpert search={searchValue} />
        </div>
      </div>
    )
  );
}
